import {Editor} from 'tinymce';
import {getMergeTagsEditable, getMergeTagsPrefix, getMergeTagsSuffix} from './Options';
import * as Actions from '../core/Actions';
import * as MergeTag from '../core/MergeTag';
import {COMMAND_NAME} from '../constants';

const register = (editor: Editor): void => {
  const prefixOption = getMergeTagsPrefix(editor);
  const suffixOption = getMergeTagsSuffix(editor);
  const editable = getMergeTagsEditable(editor);

  editor.addCommand(COMMAND_NAME, (ui: boolean, value: string) => {
    const mergeTag = MergeTag.create(value, prefixOption, suffixOption, editable);
    Actions.insertContent(editor, mergeTag);
  });
};

export {
  register
};
